import {
  reactQueryDelete,
  reactQueryGet,
} from "../helpers/backendRequestHelpers";
import { internalApi } from "../helpers/urlHelpers";

interface GetSpotlightItemsParams {
  roomId?: string | number;
  params?: Record<string, unknown>;
}

const getSpotlightItems = ({ roomId, params = {} }: GetSpotlightItemsParams) =>
  reactQueryGet(internalApi.liveStreams.spotlightItems({ roomId, params }));

interface ClearSpotlightItemsParams {
  roomId?: string | number;
}

const clearSpotlightItems = ({ roomId }: ClearSpotlightItemsParams) =>
  reactQueryDelete(internalApi.liveStreams.clearSpotlightItems({ roomId }));

export const spotlightApi = {
  getSpotlightItems,
  clearSpotlightItems,
};
